import { parseResponse } from '$lib/client/responseHelpers';

import { client } from '@api/client';
import type { CreatedFavorite } from '@api/types';

export async function getFavoritesPaginated(cursor?: number, limit?: number) {
    return client.GET('/favorite/list', {
        params: {
            query: {
                cursor,
                limit,
            },
        },
    });
}

export async function getFavoritedByPaginated(cursor?: number, limit?: number) {
    return client.GET('/favorite/favoritedBy', {
        params: {
            query: {
                cursor,
                limit,
            },
        },
    });
}

export async function toggleFavorite(userId: string, storyId?: string): Promise<{ ok: boolean; canCall: boolean}> {
    const response = await client.PATCH('/favorite/toggle', {
        body: {
            userId,
            storyId,
        },
    });
    return {
        ok: response.response.ok,
        canCall: response.data as boolean,
    };
}

export async function pairFavoritesWithReferrer(): Promise<CreatedFavorite[]> {
    const response = await client.POST('/favorite/pair-with-referrer', {
        body: {},
    });
    return parseResponse<CreatedFavorite[]>(response);
}
